import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { MachineOverviewItem } from "./models";

export const overviewApi = createApi({
  baseQuery,
  reducerPath: "overviewApi",
  tagTypes: ["Overview"],
  endpoints: (builder) => ({
    getMachineOverview: builder.query<MachineOverviewItem[], void>({
      query: () => ({
        url: "/api/v1/tasks/machine_overview/",
        method: "GET",
      }),
      providesTags: ["Overview"],
    }),
  }),
});

export const { useGetMachineOverviewQuery } = overviewApi;
